// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"9e27aa61","147":"d5b3fd7e","295":"1844400f","362":"e069bb59","420":"3be187a8","574":"8ad27a79","736":"edffa1a3","807":"aa576f98","899":"7cf24209","900":"7091b3db","996":"af35222e"}[chunkId] + ".chunk.js";
};